import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { TextField } from '@prototype'
import * as utils from '@utils'
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@material-ui/core'

class EventDragonTigerAwardsDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'MsgDialog')
        }
    }

    state = {
        dialogType: 'add',
        type: '',
        amount: '',
        count: '1',
        data: [],
        validStatus: false
    }

    componentDidMount() {
        let amount = ''
        if (this.props.dialogType === 'edit' && this.props.data.length === 1) {
            amount = this.props.data[0].money
        }
        this.setState({
            dialogType: this.props.dialogType,
            type: this.props.type,
            amount,
            data: this.props.data
        })
    }

    handleValid() {
        let valid = true
        /** 驗證彩金 */
        if (Number(this.state.amount) < 1 || Number(this.state.amount) > 9999 || !this.state.amount) {
            valid = false
        }
        /** 驗證數量 */
        if (this.props.dialogType === 'add' && (Number(this.state.count) < 1 || Number(this.state.count) > 1000 || !this.state.count)) {
            valid = false
        }
        return valid
    }
    /** 彩金錯誤訊息 */
    handleAmountErrorMsg() {
        if ((Number(this.state.amount) < 1 || !this.state.amount)) {
            return utils.t('ValidationMsg.inputCannotLessThan') + '1'
        } else if (Number(this.state.amount) > 9999) {
            return utils.t('ValidationMsg.inputCannotGreaterThan') + '9999'
        } else {
            return ''
        }
    }

    /** 總數量錯誤訊息 */
    handleCountErrorMsg() {
        if ((Number(this.state.count) < 1 || !this.state.count)) {
            return utils.t('ValidationMsg.inputCannotLessThan') + '1'
        } else if (Number(this.state.count) > 1000) {
            return utils.t('ValidationMsg.inputCannotGreaterThan') + '1000'
        } else {
            return ''
        }
    }

    confirm() {
        this.setState({
            validStatus: true
        })
        if (!this.handleValid()) { return false }
        const {amount, count} = this.state
        this.props.confirm(amount, count)
    }

    closeDialog() {
        this.props.closeDialog()
    }

    render() {

        return (
            <Dialog open={true} maxWidth={'xs'} fullWidth>
                <DialogTitle>{this.t(this.props.dialogType)}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                className={this.props.classes.textField}
                                label={utils.t('money', 'EventDialog', { currency: `(${this.t('gameCurrency')})` })}
                                value={this.state.amount}
                                onChange={(event) =>
                                    this.setState({
                                        amount: event.target.value,
                                    })
                                }
                                error={this.state.validStatus && (Number(this.state.amount) < 1 || Number(this.state.amount) > 9999 || !this.state.amount)}
                                helperText={this.state.validStatus && this.handleAmountErrorMsg()}
                            />
                        </Grid>
                        {this.props.dialogType === 'add' && <Grid item xs={12}>
                            <TextField
                                className={this.props.classes.textField}
                                label={utils.t('amount', 'EventDialog')}
                                value={this.state.count}
                                onChange={(event) =>
                                    this.setState({
                                        count: event.target.value,
                                    })
                                }
                                error={this.state.validStatus && (Number(this.state.count) < 1 || Number(this.state.count) > 1000 || !this.state.count)}
                                helperText={this.state.validStatus && this.handleCountErrorMsg()}
                            />
                        </Grid>}
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button variant="contained" onClick={() => this.confirm()} color="primary">
                        {this.t(this.props.dialogType === 'add' ? 'confirm' : 'save')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {}
}

EventDragonTigerAwardsDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    closeDialog: PropTypes.func,
    confirm: PropTypes.func,
    type: PropTypes.string.isRequired,
    dialogType: PropTypes.string.isRequired,
    data: PropTypes.array,
}

export default hoc(styles)(EventDragonTigerAwardsDialog)
